// extracted by mini-css-extract-plugin
export default {"carouselFallbackImage":"style-module--carousel-fallback-image--41fd1"};